import type { MaybeFalsy } from '@soundxyz/utils';
import { getManyFromList } from '@soundxyz/utils';
import { isNonEmptyArray } from './list';

export function sortFieldsInput<
  const FieldsNames extends string,
  const Fields extends ReadonlyArray<
    MaybeFalsy<{
      field: FieldsNames;
      order: MaybeFalsy<'ASC' | 'DESC'>;
    }>
  >,
>(...input: Fields) {
  const sort = getManyFromList(
    input,
    value => !!value && !!value.order && { field: value.field, order: value.order },
  );

  return isNonEmptyArray(sort) ? sort : undefined;
}
